import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Data, Table } from 'components/layout/Table'
import { awardsProgressOverview as layout } from 'constants/layout'
import config from 'config'
import get from 'lodash/get'
import { BadgesLevels } from '../../../misc'
import { LEVELS } from '../../../../constants/enums'
import { injectIntl } from 'react-intl'
import styles from './awards-progress-overview-table.styl'
import cx from 'classnames'
import { Export } from '../../../../containers/misc'


@injectIntl
class AwardsProgressOverviewTable extends PureComponent {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    awardsProgressOverview: PropTypes.object.isRequired,
    setAwardsProgressOverviewParams: PropTypes.func,
    setCommonLimit: PropTypes.func,
    intl: PropTypes.object,
    exportAwardProgressOverview: PropTypes.func.isRequired,
  }
  static defaultProps = {
    permissions: {}
  }

  render() {
    const {
      permissions,
      setAwardsProgressOverviewParams,
      setCommonLimit,
      awardsProgressOverview,
      intl
    } = this.props

    const exportComponent = (
      <Export
        exportName="Award progress overview"
        toExport={this.props.exportAwardProgressOverview}
        exportSchemeValue="award-progress-overview"
        count={this.props.awardsProgressOverview && this.props.awardsProgressOverview.count}
      />
    )

    const isAuVisible = (permissions.isIf || permissions.isNaoStaff)

    let loading = get(awardsProgressOverview, 'loading')
    let list = get(awardsProgressOverview, 'list')
    let offset = get(awardsProgressOverview, 'offset')
    let limit = get(awardsProgressOverview, 'limit')
    let pages = get(awardsProgressOverview, 'pages')
    let sort = get(awardsProgressOverview, 'sort')
    let count = get(awardsProgressOverview, 'countLoaded') && get(awardsProgressOverview, 'count')

    const renderActivityCell = (activity, cellClassName) => {
      const percent = get(activity, 'completedPercentage') || 0
      const hours = get(activity, 'completedHours') || 0
      const progressText = (percent || hours)
        ? intl.formatMessage({
            id: 'table.progress_template',
            defaultMessage: '{0}% ({1} hours)',
          }, [percent, hours])
        : ''

      return (
        <td className={cx(styles.cellCenter, cellClassName)}>
          <div className={styles.firstLine}>
            {get(activity, 'lastAction.value') || get(activity, 'lastAction.type')}
          </div>
          <div className={styles.bolder}>
            {progressText}
          </div>
        </td>
      )
    }

    const renderAjRpCell = (data, cellClassName) => {
      return (
        <td className={cx(styles.cellCenter, cellClassName)}>
          <div>
            {get(data, 'lastAction.value') || get(data, 'lastAction.type')}
          </div>
        </td>
      )
    }

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          count={count}
          sort={sort}
          ths={layout.tableHeaders(isAuVisible)}
          setParams={setAwardsProgressOverviewParams}
          permissions={permissions}
          exportComponent={exportComponent}
        >

          <Data>
            {list.map(
              ({
                 participant,
                 progress,
                 award,
                 organization
               }) => {
                const pid = get(participant, 'id')
                const globalId = get(participant, 'globalId')
                const firstName = get(participant, 'firstName')
                const lastName = get(participant, 'lastName')
                const skill = get(progress, 'act.skill')
                const physical = get(progress, 'act.physicalRecreation')
                const service = get(progress, 'act.voluntaryService')
                const practice = get(progress, 'aj.practice')
                const qualification = get(progress, 'aj.qualification')
                const rp = get(progress, 'rp')
                const state = get(award, 'state')
                const isBronzeAward = get(award, 'level.type') === LEVELS.BRONZE.value
                const isSilverAward = get(award, 'level.type') === LEVELS.SILVER.value
                const isGoldAward = get(award, 'level.type') === LEVELS.GOLD.value
                const key = pid + get(award, 'level.type')

                return (
                  <tr key={key}>

                    <td className={styles.cellCenter}>
                      <div className={cx(styles.firstLine, styles.bolder)}>
                        {firstName} {lastName}
                      </div>
                      <div>
                        <Link
                          to={{ pathname: `${config.publicPath}/participants/${pid}/detail` }}
                        >
                          {globalId}
                        </Link>
                      </div>
                    </td>

                    {isAuVisible && <td className={styles.cellCenter}>
                      <div className={cx(styles.firstLine, styles.bolder)}>
                        {get(organization, 'name')}
                      </div>
                      <div>
                        <Link to={{ pathname: `${config.publicPath}/award-units/${get(organization, 'id')}/detail` }}>{get(organization, 'globalId')}</Link>
                      </div>
                    </td>}

                    <td className={styles.cellCenter}>
                      <div className={styles.firstLine}>
                        {get(state, 'value') || get(state, 'type')}
                      </div>
                      <div>
                        <BadgesLevels
                          hasGold={isGoldAward}
                          hasSilver={isSilverAward}
                          hasBronze={isBronzeAward}
                          participantId={pid}
                          small
                        />
                      </div>
                    </td>

                    {renderActivityCell(physical, styles.cellPhysical)}

                    {renderActivityCell(skill, styles.cellSkill)}

                    {renderActivityCell(service, styles.cellService)}

                    {renderAjRpCell(practice, styles.cellAj)}

                    {renderAjRpCell(qualification, styles.cellAj)}

                    {renderAjRpCell(rp, styles.cellRp)}

                  </tr>
                )
              }
            )}
          </Data>
        </Table>
      </div>
    )
  }
}

export default AwardsProgressOverviewTable

